var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9538 8.16565L9.0838 20.0357C8.0238 21.1057 4.85378 21.5956 4.13378 20.8856C3.41378 20.1756 3.92379 17.0057 4.98379 15.9357L16.8538 4.06568C17.4019 3.54369 18.1323 3.25665 18.8891 3.26587C19.646 3.2751 20.3692 3.57986 20.9044 4.11506C21.4396 4.65025 21.7443 5.37349 21.7536 6.13031C21.7628 6.88714 21.4758 7.61757 20.9538 8.16565Z",
    stroke: "#929CAC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.04f1840f65bd80e09a6a3cc1a87e1240.svg";
export { ForwardRef as ReactComponent };